import { FC } from 'react';
import { noop } from 'lodash-es';
import { useGetThemeConfig } from '@namespace/themes';
import { propsMerge } from '../../utils/propsMerge';
import { DesktopSelect } from './components/DesktopSelect';
import { MobileSelect } from './components/MobileSelect';
import { SelectProps } from './types';

export const Select: FC<SelectProps> = (props) => {
  const selectConfig = useGetThemeConfig('Select');
  const {
    options = [],
    value,
    onChange = noop,
    onBlur = noop,
    disabled,
    placeholder,
    isDesktop,
    size,
    arrowSize,
    intent,
    style,
    className,
    CustomTrigger,
    CustomContent,
    dataRole,
    additionSelectContentStyle = '',
    additionalPopoverStyle = '',
    additionalMobileSelectStyle = '',
    additionSelectTitleStyle = '',
    additionSelectOptionStyle = {},
    additionSelectStyles = {},
    haveToCloseOutsideClick = true,
    hasIcon = false,
    hasCheck = true,
    selectType,
    noPlaceholderColor = false,
    hasSearch = false,
    hasDesktopSelect = false,
    emptyText = '',
    intentType,
    showDropdownIconWhenOnlyOneOption = true,
    disableDropdownWhenOnlyOneOption = false,
    isExpandable = false,
    isOpenExternal,
    setIsOpenExternal,
    iconDropDownName,
    contentSize,
    contentAfter,
    ...rest
  } = propsMerge(props, selectConfig);

  const commonProps = {
    options,
    value,
    onChange,
    onBlur,
    disabled,
    placeholder,
    size,
    arrowSize,
    intent,
    className,
    style,
    dataRole,
    selectType,
    noPlaceholderColor,
    hasIcon,
    hasCheck,
    hasSearch,
    emptyText,
    showDropdownIconWhenOnlyOneOption,
    disableDropdownWhenOnlyOneOption,
    iconDropDownName,
    contentSize,
    isExpandable,
    isOpenExternal,
    setIsOpenExternal,
    contentAfter,
    ...rest
  };

  return isDesktop || hasSearch || hasDesktopSelect ? (
    <DesktopSelect
      {...commonProps}
      haveToCloseOutsideClick={haveToCloseOutsideClick}
      CustomTrigger={CustomTrigger}
      CustomContent={CustomContent}
      additionSelectContentStyle={additionSelectContentStyle}
      additionalPopoverStyle={additionalPopoverStyle}
      additionSelectTitleStyle={additionSelectTitleStyle}
      additionSelectStyles={additionSelectStyles}
      additionSelectOptionStyle={additionSelectOptionStyle}
      intentType={intentType}
    />
  ) : (
    <MobileSelect
      mobileSelectStyle={additionalMobileSelectStyle}
      intentType={intentType}
      {...commonProps}
    />
  );
};
